import isNil from './is-nil';
export default (function (value) {
    if (isNil(value))
        return '';
    return value.toString();
});
//# sourceMappingURL=to-string.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/to-string.js
// module id = 63
// module chunks = 3